// OFHSD-963 — rendering rules for the Reporting grid's engine-hours and odometer columns.
//
// A reading arrives with a provenance: "ecu" for a real vehicle-bus meter, "gps" for MyGeotab's
// GPS-derived substitute. The substitute is shown — the customer can already see it in MyGeotab —
// but it is never allowed to look like a meter reading, because it is not one and must not be used
// for PM intervals, warranty, or meter-based billing.
//
// Null means "no reading"; zero means "a reading of zero". They render differently.

const GPS_MARKER = " (GPS)";

function present(value) {
  return value !== null && value !== undefined && !Number.isNaN(value);
}

function mark(text, source) {
  return source === "gps" ? text + GPS_MARKER : text;
}

function round(value) {
  return value.toLocaleString(undefined, { maximumFractionDigits: 0 });
}

export function formatEngineHours(value, source) {
  if (!present(value)) return null;
  return mark(round(value), source);
}

export function formatOdometer(value, source) {
  if (!present(value)) return null;
  return mark(round(value) + " mi", source);
}
